import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import InputNumberNoScroll from "../../../../../components/inputs/inputNumberNoScroll";

export default function EditarIva({ initial, onClose = () => {}, onSaved = () => {} }) {
  const id = useMemo(() => initial?.id ?? null, [initial]);
  const [codigo, setCodigo] = useState(initial?.codigo || "");
  const [nombre, setNombre] = useState(initial?.nombre || "");
  const [pr, setPr] = useState(initial?.pr ?? "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = codigo.trim() !== "" && nombre.trim() !== "" && pr !== "";
  const changed = useMemo(() => {
    return codigo !== (initial?.codigo || "") ||
           nombre !== (initial?.nombre || "") ||
           String(pr) !== String(initial?.pr ?? "");
  }, [codigo, nombre, pr, initial]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
        pr: Number(pr),
      };
      const updated = await appFetchJson(apiRoutes.ivas.update(id), {
        method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
      });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando IVA:", e);
      setError(e?.message || "Error al actualizar el IVA.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar IVA</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Modifique los datos del IVA</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="space-y-4">
            <div><label className="form-label">Código *</label><input type="text" className="input" value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="Código del IVA" /></div>
            <div><label className="form-label">Descripción *</label><input type="text" className="input" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre del IVA" /></div>
            <div>
              <label className="form-label">Porcentaje *</label>
              <InputNumberNoScroll
                step="1"
                className="input"
                value={pr}
                onChange={e => setPr(e.target.value === "" ? "" : Number(e.target.value))}
                placeholder="Porcentaje de IVA"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid && changed} saving={saving} onClick={handleSave} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}